import { hanwahaInstance } from '../../../shared_elements';
const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';

export const getClasses = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/${qbProvider}/auth-url/${queryString ? `?${queryString}` : ''}`;
};

export const getClassesListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/${qbProvider}/classes/${queryString ? `?${queryString}` : ''}`;
};
